import { Delete, Get, Post, Put, setFixHeader } from "../utils/request";

const currentUser: API.CurrentUser = {
    name: "",
    isAdmin: true,
    menus : [],
    token: ""
};
export const getCurrentUser = (): API.CurrentUser => {
    return currentUser;
}

//增加用户
export const addUser = async (userInfo: API.User) => {
    console.log("add user", userInfo);
    let result = await Post("/users", null, userInfo);
    if (result.code == 0)
        return true;
    throw result.message;
}

//更新用户
export const updateUser = async (userInfo: API.User) => {
    console.log("update user", userInfo);
    let result = await Put("/users", null, userInfo);
    if (result.code == 0)
        return true;
    throw result.message;
}


//删除用户
export const removeUser = async (id: number) => {
    await Delete(`/users/${id}`)
}


export const listUser = async (): Promise<API.User[]> => {

    let result = await Get("/users");

    return result.data;
}

export const fetchCurrentUser = async (): Promise<API.User> => {

    let result = await Get("/users/detail");

    return result.data[0];
}

export const login = async (param: API.LoginParams) => {
    let result: API.LoginResult = await Post(`/users/login?client=${param.client}`, {}, param);

    if (result.code == 0) {
        currentUser.isAdmin = false;
        currentUser.name = param.username;
        currentUser.token = result.token ? result.token : "";       
        setFixHeader("x-auth-token", currentUser.token)
        const menus = await Get(`/users/menus`, {});
        const m = menus.data.map((v2:any)=>{
            return {
                key : v2.menuid,
                label : v2.name
            }
        })
        currentUser.menus = m
        return result.token;
    }
    throw result.message ? result.message : "登录时遇到错误！";
}

export const verifyLogin = async (token: string) => {
    let result: API.LoginResult = await Get("/users", { "x-auto-token": token });

    if (result.code == 0) {
        setFixHeader("x-auth-token", token)
        return true;
    } else
        return false;
}

export const changePassword = async (password: string) => {
    let result: API.LoginResult = await Post("/users/changePassword", {}, { password });
}

export const logout = async () => {
    currentUser.name = "";
    currentUser.token = "";

}



//设置分组
export async function setUserGroups(userId: number, data: any) {
    await Post(`/users/${userId}/groups`, {}, { ids: data });
}


//设置菜单
export async function setUserMenus(userId: number, data: any) {
    await Post(`/users/${userId}/menus`, {}, { ids: data });
}
